// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { generateUniqueId } from '../../internal/hooks/use-unique-id';
export var useDropdownA11yProps = function (listId, expanded, inputAriaLabel, highlightedOption) {
    var itemProps = {};
    var inputProps = {
        role: 'combobox',
        'aria-autocomplete': 'list',
        'aria-expanded': expanded,
        'aria-controls': listId,
        // 'aria-owns' needed for safari+vo to announce activedescendant content
        'aria-owns': listId
    };
    if (inputAriaLabel) {
        inputProps['aria-label'] = inputAriaLabel;
    }
    if (highlightedOption) {
        var id = generateUniqueId();
        itemProps.id = id;
        inputProps['aria-activedescendant'] = id;
    }
    return [inputProps, itemProps];
};
//# sourceMappingURL=a11y.js.map